module.exports = __webpack_public_path__ + "img/logo-dark.e7aab0cd.png";